import { render } from "./404.vue?vue&type=template&id=4af85800&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=4af85800&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af85800"]])

export default __exports__